import DriverRoute from "./DriverRoute";

const RouteLines = ({ drivers, map }) => {
  return (
    <>
      {drivers.map((driver) => (
        <DriverRoute key={driver.driverId} driver={driver} map={map} />
      ))}
    </>
  );
};

export default RouteLines;